<template>
    <main>
      <TopSection></TopSection>
      <Services></Services>
      <Exp></Exp>
      <Stats></Stats>
      <Contact></Contact>
    </main>
</template>

<script>
import TopSection from './Home/TopSection.vue';
import Services from './Home/Services.vue';
import Exp from './Home/Exp.vue';
import Stats from './Home/Stats.vue';
import Contact from './Home/Contact.vue';
export default {
    name: "home-component",
    components: { TopSection, Services, Exp, Stats, Contact }
}
</script>